import { render, staticRenderFns } from "./ColoredBox.vue?vue&type=template&id=79c572bc&scoped=true&lang=pug&"
import script from "./ColoredBox.vue?vue&type=script&lang=ts&"
export * from "./ColoredBox.vue?vue&type=script&lang=ts&"
import style0 from "./ColoredBox.vue?vue&type=style&index=0&id=79c572bc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c572bc",
  null
  
)

export default component.exports